import { useCallback } from 'react';
import { ApiServerEntityIDType } from '@cp/utils/apiServer/types';
import { useToast } from '@cp/shared/toast';
import { coreClientApi } from 'src/entities/client';

export const useClientImpersonation = () => {
  const [impersonate, { isLoading }] = coreClientApi.endpoints.impersonate.useMutation();
  const createToast = useToast();

  const openAsClient = useCallback(
    async (clientId: ApiServerEntityIDType) => {
      if (!window.confirm('Войти под этим пользователем?')) {
        return;
      }

      // Open synchronously in the click handler so the browser does not block the popup
      // after the async API round-trip.
      const popup = window.open('about:blank', '_blank');
      try {
        const { url } = await impersonate({ id: clientId }).unwrap();
        if (popup) {
          popup.opener = null;
          popup.location.href = url;
          return;
        }
        window.location.assign(url);
      } catch {
        popup?.close();
        createToast('error', 'Не удалось войти под пользователем. Попробуйте ещё раз.');
      }
    },
    [impersonate, createToast],
  );

  return { openAsClient, isLoading };
};
